import type { LinkComponent, Topic } from "@op/puck-types";
import { Button, Ow_ProjectCard } from "@op/sf-op";
import Medium from "../../../../../../components/puck/Medium/Medium";
import { clx, useTranslation } from "@op/utils";
import { useMemo } from "react";

export interface TopicSectionProps extends Topic {
  languageKey: string;
  noAccent?: boolean;
  LinkComponent: LinkComponent;
}

export const TopicSection = ({
  noAccent = false,
  LinkComponent,
  languageKey,
  slug,
  name,
  pages,
}: TopicSectionProps) => {
  const accent = useMemo(() => !noAccent, [noAccent]);
  const { projectPage: trans } = useTranslation();

  return (
    <div
      className={clx({
        "flex w-full flex-col items-center": true,
        "bg-default-background": noAccent,
        "bg-neutral-50": !noAccent,
      })}
    >
      <div className="flex w-full max-w-[920px] flex-col items-start gap-16 px-8 py-16">
        <div className="flex w-full items-center justify-between">
          <span className="text-heading-1 font-heading-1 text-neutral-900">
            {name}
          </span>
          <LinkComponent
            to="/$languageKey/$topicSlug"
            className="contents"
            params={{
              languageKey: languageKey,
              topicSlug: slug,
            }}
          >
            <Button size="large">{trans.toTopic}</Button>
          </LinkComponent>
        </div>
        <div className="flex w-full items-start gap-8">
          {pages.map((page) => (
            <LinkComponent
              to="/$languageKey/$topicSlug/$pageSlug"
              className="contents"
              key={page.id}
              params={{
                languageKey: languageKey,
                topicSlug: slug,
                pageSlug: page.slug,
              }}
            >
              <Ow_ProjectCard
                className="max-w-[400px]"
                title={page.title ?? page.name}
                description={page.description}
                accent={accent}
              >
                {page.image && <Medium cover medium={page.image} noContainer />}
              </Ow_ProjectCard>
            </LinkComponent>
          ))}
        </div>
      </div>
    </div>
  );
};
